// pages/_app.tsx
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'styles/reset.scss'
import 'styles/404.scss'
import 'components/commons/Header/headerfooter.css'
import { AppProps } from 'next/app'
import Layout from 'components/commons/Layout'
import Header from 'components/commons/Header'
import Footer from 'components/commons/Footer'
import LocalStorage from 'components/commons/LocalStorage'
import { addGTMToBody } from 'lib/functions'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const App: React.FC<AppProps> = ({ Component, pageProps }: AppProps) => {
  const router = useRouter()
  addGTMToBody()

  // 特定のページのみ異なるスタイルを適用
  const lpPages = [
    '/services/appgrowth',
    '/services/backend-dev',
    '/services/frontend-dev',
    '/services/designsystem',
    '/services/uiuxdesign-lp2',
    '/lp_ui',
  ]

  useEffect(() => {
    const loadStyle = async () => {
      if (lpPages.includes(router.pathname)) {
        await import('styles/HubSpotFormStyleLP.scss')
      } else {
        await import('styles/HubSpotFormStyle.scss')
      }

      if (router.pathname.includes('/services/flamingo')) {
        await import('components/LP/FlamingoLP/reset.scss')
      }
    }
    loadStyle()
  }, [router.pathname])

  return (
    <>
      <LocalStorage />
      <Header />
      <Layout>
        <Component {...pageProps} />
      </Layout>
      <Footer />
    </>
  )
}

export default App
